const companyForms = [
	['Aafy', 'AAFY'],
	['Ados', 'ADOS'],
	['Anna', 'ANNA'],
	['Ans', 'ANS'],
	['As', 'AS'],
	['Asa', 'ASA'],
	['Ba', 'BA'],
	['Bbl', 'BBL'],
	['Bedr', 'BEDR'],
	['Bo', 'BO'],
	['Brl', 'BRL'],
	['Da', 'DA'],
	['Enk', 'ENK'],
	['Eofg', 'EOFG'],
	['Esek', 'ESEK'],
	['Fkf', 'FKF'],
	['Fli', 'FLI'],
	['Fylk', 'FYLK'],
	['Gfs', 'GFS'],
	['Ikjp', 'IKJP'],
	['Iks', 'IKS'],
	['Kbo', 'KBO'],
	['Kf', 'KF'],
	['Kirk', 'KIRK'],
	['Komm', 'KOMM'],
	['Ks', 'KS'],
	['Ktrf', 'KTRF'],
	['Nuf', 'NUF'],
	['Opmv', 'OPMV'],
	['Orgl', 'ORGL'],
	['Pers', 'PERS'],
	['Pk', 'PK'],
	['Pre', 'PRE'],
	['Sa', 'SA'],
	['Sam', 'SAM'],
	['Se', 'SE'],
	['Sf', 'SF'],
	['Spa', 'SPA'],
	['Sti', 'STI'],
	['Stat', 'STAT'],
	['Sær', 'SÆR'],
	['Tvam', 'TVAM'],
	['Utla', 'UTLA'],
	['Vpfo', 'VPFO']
]

export function toTitleCase(str) {
	let newText = str.replace(
		/[a-zA-Z0-9_ÆØÅ]\S*/g,
		function (txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		}
	);
	companyForms.forEach(form => {
		const regex = new RegExp("s*" + form[0] + '$')
		if(newText.match(regex)){
			newText = newText.replace(regex, form[1]);
		}
	})
	if(newText.includes(' Og ')) {
		newText = newText.replace(' Og ', ' og ');
	}
	if(newText.includes('Mna')) {
		newText = newText.replace('Mna', '');
	}
	return newText
}